module.exports = __webpack_public_path__ + "static/media/update.c72f7727.svg";